import { formValidation, useValidateForm } from "cja-phoenix";

export const useNewsletterSignup = () => {
  const { t } = useI18n();

  const email = ref();
  const emailInput = ref();

  const tcConsent = ref(false);
  const tcConsentInput = ref();

  const { update, status } = useCustomFetch("/api/blog/newsletter/add", {
    method: "POST",
    body: {
      email,
    },
  });

  const emailValidation = formValidation.email({
    required: t("input.error.required"),
    email: t("input.error.email"),
  });

  const tcConsentValidation = formValidation.boolean(
    {
      strictValue: t("input.error.tc"),
    },
    {
      strictValue: true,
    }
  );

  const { submit } = useValidateForm({
    fields: [emailInput, tcConsentInput],
    onSubmit: update,
    submitLock: true,
  });

  return {
    submit,
    status,
    email,
    emailInput,
    emailValidation,
    tcConsent,
    tcConsentInput,
    tcConsentValidation,
  };
};
